/*
 * women-video-lightbox.js — O.C. WOMEN'S HAIR
 * Fängt Klicks auf Video-Links (YouTube / Vimeo / MP4 / Shopify-CDN) ab und öffnet sie
 * in einem sauberen On-Page-Overlay, statt aus der Seite rauszulinken (Funnel bleibt erhalten).
 * Wirkt NUR auf <a href="…video…">-Buttons; Inline-<video> und Hero-Autoplay sind nicht betroffen.
 * Opt-out pro Link: Attribut data-no-lightbox.
 */
(function () {
  'use strict';

  function parse(raw) {
    if (!raw) return null;
    var u;
    try { u = new URL(raw, window.location.href); } catch (e) { return null; }
    var h = u.hostname.replace(/^www\./, '');
    if (h === 'youtu.be') { var id = u.pathname.slice(1).split('/')[0]; return id ? { type: 'yt', id: id } : null; }
    if (h === 'youtube.com' || h === 'm.youtube.com' || h === 'youtube-nocookie.com') {
      if (u.pathname === '/watch') { var v = u.searchParams.get('v'); return v ? { type: 'yt', id: v } : null; }
      var my = u.pathname.match(/^\/(?:embed|shorts)\/([^/?#]+)/); if (my) return { type: 'yt', id: my[1] };
      return null;
    }
    if (h === 'vimeo.com') { var mv = u.pathname.match(/\/(\d+)/); return mv ? { type: 'vimeo', id: mv[1] } : null; }
    if (h === 'player.vimeo.com') { var mp = u.pathname.match(/\/video\/(\d+)/); return mp ? { type: 'vimeo', id: mp[1] } : null; }
    if (/\.(mp4|webm|mov|m4v)(\?|#|$)/i.test(u.pathname) || /\/videos\//.test(u.pathname)) return { type: 'file', src: u.href };
    return null;
  }

  var overlay = null, lastFocus = null;

  function styles() {
    if (document.getElementById('wvl-css')) return;
    var s = document.createElement('style');
    s.id = 'wvl-css';
    s.textContent =
      '.wvl-ov{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:24px;background:rgba(30,26,22,.85);opacity:0;transition:opacity .18s ease}' +
      '.wvl-ov.on{opacity:1}' +
      '.wvl-box{position:relative;width:100%;max-width:960px}' +
      '.wvl-16x9{position:relative;width:100%;aspect-ratio:16/9;background:#000;border-radius:16px;overflow:hidden;box-shadow:0 24px 70px rgba(0,0,0,.45)}' +
      '.wvl-16x9 iframe{position:absolute;inset:0;width:100%;height:100%;border:0}' +
      '.wvl-vid{display:block;width:auto;max-width:100%;max-height:82vh;margin:0 auto;border-radius:16px;background:#000;box-shadow:0 24px 70px rgba(0,0,0,.45)}' +
      '.wvl-x{position:absolute;top:-16px;right:-16px;width:42px;height:42px;border:0;border-radius:999px;cursor:pointer;background:#fff;color:#1e1a16;font-size:24px;line-height:42px;text-align:center;padding:0;box-shadow:0 4px 16px rgba(0,0,0,.3)}' +
      '.wvl-x:hover{background:#efe9e0}' +
      '@media(max-width:640px){.wvl-x{top:-48px;right:0}}';
    document.head.appendChild(s);
  }

  function onKey(e) { if (e.key === 'Escape' || e.keyCode === 27) close(); }

  function close(immediate) {
    if (!overlay) return;
    document.removeEventListener('keydown', onKey);
    var ov = overlay; overlay = null;
    document.body.style.overflow = '';
    if (immediate) { if (ov.parentNode) ov.parentNode.removeChild(ov); }
    else {
      ov.classList.remove('on');
      setTimeout(function () { if (ov.parentNode) ov.parentNode.removeChild(ov); }, 220);
    }
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function open(media) {
    styles();
    close(true);
    overlay = document.createElement('div');
    overlay.className = 'wvl-ov';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Video');
    var box = document.createElement('div');
    box.className = 'wvl-box';
    var x = document.createElement('button');
    x.className = 'wvl-x'; x.type = 'button';
    x.setAttribute('aria-label', 'Video schließen'); x.innerHTML = '×';
    box.appendChild(x);
    if (media.type === 'file') {
      var vid = document.createElement('video');
      vid.className = 'wvl-vid'; vid.src = media.src;
      vid.controls = true; vid.autoplay = true; vid.playsInline = true; vid.setAttribute('playsinline', '');
      box.appendChild(vid);
    } else {
      var f = document.createElement('div'); f.className = 'wvl-16x9';
      var ifr = document.createElement('iframe');
      if (media.type === 'yt') {
        ifr.src = 'https://www.youtube-nocookie.com/embed/' + media.id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
        ifr.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      } else {
        ifr.src = 'https://player.vimeo.com/video/' + media.id + '?autoplay=1';
        ifr.allow = 'autoplay; fullscreen; picture-in-picture';
      }
      ifr.setAttribute('allowfullscreen', '');
      f.appendChild(ifr);
      box.appendChild(f);
    }
    overlay.appendChild(box);
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    overlay.getBoundingClientRect();
    overlay.classList.add('on');
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    x.addEventListener('click', function () { close(); });
    document.addEventListener('keydown', onKey);
    lastFocus = document.activeElement;
    try { x.focus(); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('a[href]');
    if (!a || a.hasAttribute('data-no-lightbox')) return;
    var media = parse(a.getAttribute('href'));
    if (!media) return;
    e.preventDefault();
    open(media);
  });
})();
